(function () {
  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function init(root) {
    var viewport = root.querySelector("[data-ir-results-viewport]");
    var controls = root.querySelector("[data-ir-results-controls]");
    var range = root.querySelector("[data-ir-results-range]");
    var prev = root.querySelector("[data-ir-results-prev]");
    var next = root.querySelector("[data-ir-results-next]");
    var track = root.querySelector(".ir-stories__track");
    if (!viewport || !controls || !range || !prev || !next || !track) return;

    var isSyncingFromRange = false;
    var isSyncingFromScroll = false;

    function getMaxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function getStep() {
      var first = track.querySelector(".ir-story-card");
      if (!first) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = getMaxScroll();
      prev.disabled = viewport.scrollLeft <= 1;
      next.disabled = viewport.scrollLeft >= maxScroll - 1;
      prev.style.opacity = prev.disabled ? "0.45" : "1";
      next.style.opacity = next.disabled ? "0.45" : "1";
    }

    function updateThumbWidth() {
      var trackW = range.getBoundingClientRect().width;
      if (trackW <= 0) return;

      var maxScroll = getMaxScroll();
      var visibleRatio = viewport.scrollWidth <= 0 ? 1 : viewport.clientWidth / viewport.scrollWidth;

      var thumbW = clamp(trackW * visibleRatio, 70, trackW);
      range.style.setProperty("--ir-thumb-w", thumbW + "px");
      range.disabled = maxScroll <= 0;
    }

    function syncRangeFromScroll() {
      if (isSyncingFromRange) return;

      var maxScroll = getMaxScroll();
      var ratio = maxScroll <= 0 ? 0 : viewport.scrollLeft / maxScroll;
      var v = Math.round(clamp(ratio, 0, 1) * 1000);

      isSyncingFromScroll = true;
      range.value = String(v);
      isSyncingFromScroll = false;

      updateButtons();
    }

    function syncScrollFromRange() {
      if (isSyncingFromScroll) return;

      var maxScroll = getMaxScroll();
      var v = parseInt(range.value || "0", 10);
      var ratio = clamp(v / 1000, 0, 1);
      var x = ratio * maxScroll;

      isSyncingFromRange = true;
      viewport.scrollTo({ left: x, behavior: "auto" });
      isSyncingFromRange = false;

      updateButtons();
    }

    function scrollByDir(dir) {
      var step = getStep();
      if (!step) return;
      viewport.scrollBy({ left: dir * step, behavior: "smooth" });
    }

    prev.addEventListener("click", function () {
      scrollByDir(-1);
    });

    next.addEventListener("click", function () {
      scrollByDir(1);
    });

    range.addEventListener("input", function () {
      syncScrollFromRange();
    });

    viewport.addEventListener(
      "scroll",
      function () {
        syncRangeFromScroll();
      },
      { passive: true }
    );

    function refresh() {
      updateThumbWidth();
      syncRangeFromScroll();
      updateButtons();
    }

    window.addEventListener("resize", function () {
      refresh();
    });

    refresh();
  }

  function boot() {
    var nodes = document.querySelectorAll("[data-ir-results]");
    if (!nodes.length) return;
    nodes.forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
